import { defineStore } from 'pinia'


/**
 * 翻译收集器 State
 */
interface TranslateCollectorState {
  /** 未翻译的key集合 */
  untranslatedKeys: string[]
  /** 已翻译的key集合 */
  translatedKeys: string[]
  /** 已上报的key集合 */
  reportedKeys: string[]
  /** 是否启用 */
  isEnabled: boolean
}

export const useTranslateCollectorStore = defineStore('translateCollector', {
  state: (): TranslateCollectorState => ({
    untranslatedKeys: [],
    translatedKeys: [],
    reportedKeys: [],
    isEnabled: false
  }),

  getters: {
    /** 未翻译数量 */
    untranslatedCount: (state): number => state.untranslatedKeys.length,

    /** 已翻译数量 */
    translatedCount: (state): number => state.translatedKeys.length,

    /** 总数 */
    totalCount: (state): number => state.untranslatedKeys.length + state.translatedKeys.length,

    /** 未上报的key */
    unreportedKeys: (state): string[] =>
      state.untranslatedKeys.filter(key => !state.reportedKeys.includes(key))
  },

  actions: {
    /**
     * 启动收集
     */
    start() {
      this.isEnabled = true
    },

    /**
     * 停止收集
     */
    stop() {
      this.isEnabled = false
    },

    /**
     * 收集翻译key
     * @param key 翻译key
     * @param type 翻译类型 1: 未翻译, 2: 已翻译
     */
    collect(key: string, type: number) {
      if (!this.isEnabled) return
      if (!key || typeof key !== 'string') return

      const trimmedKey = key.trim()
      if (!trimmedKey) return

      // type 1: 未翻译, type 2: 已翻译
      if (type === 1) {
        if (!this.untranslatedKeys.includes(trimmedKey)) {
          this.untranslatedKeys.push(trimmedKey)
        }
        // 从已翻译中移除
        const translatedIndex = this.translatedKeys.indexOf(trimmedKey)
        if (translatedIndex > -1) {
          this.translatedKeys.splice(translatedIndex, 1)
        }
      } else if (type === 2) {
        if (!this.translatedKeys.includes(trimmedKey)) {
          this.translatedKeys.push(trimmedKey)
        }
        // 从未翻译中移除
        const untranslatedIndex = this.untranslatedKeys.indexOf(trimmedKey)
        if (untranslatedIndex > -1) {
          this.untranslatedKeys.splice(untranslatedIndex, 1)
        }
      }

      // 持久化到 localStorage
      // this.saveToStorage()
    },

    /**
     * 清空收集
     */
    clear() {
      this.untranslatedKeys = []
      this.translatedKeys = []
      this.reportedKeys = []
    },

    /**
     * 标记已上报
     */
    markAsReported(keys: string[]) {
      keys.forEach(key => {
        if (!this.reportedKeys.includes(key)) {
          this.reportedKeys.push(key)
        }
      })
    },
  },
  persist: {
    storage: window.localStorage

  }
})

// 开发环境默认启动
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
  setTimeout(() => {
    const store = useTranslateCollectorStore()
    // store.loadFromStorage()
    store.start()
  }, 0)
}
